<template>
  <div>
    <SmallSquare content="可通过站内信或手机接收关注的节点动态；若启用手机短信订阅，请确保账户短信充足。查看短信余额" />
    <div class='m-b-20 m-t-20  s_flex_ali'>
      <span class='mr15'>
        <a-button type="primary" @click="allSet">
          <PlusOutlined />
          批量设置
        </a-button>
      </span>
    </div>
    <a-table :pagination='false' :loading='listLoading' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" bordered rowKey='id' :columns='columns' :data-source='data' >
      <template v-slot:action="{ record }">
        <a-button type="link" @click="set(record.id)" >
          设置
        </a-button>
      </template>
    </a-table>
  <!--<a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
  </div>
</template>
<script>
import { inject, reactive, ref ,toRefs} from "vue";
import { getmessage,createReceiver,delReceiver,receiverDetail,editReceiver } from "@/api/message.js";
import { iscode } from "@/utils/app";
import { message } from 'ant-design-vue';
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  setup() {
    let columns = [
  
      {
        title: "消息类型",
        dataIndex: "type_nam",
        key: "type_nam",
      },
      {
        title: "触发项目",
        dataIndex: "project",
        key: "project",
      },
       {
        title: "站内信",
        dataIndex: "create_time",
          customRender:({record})=>{
          return  record.email?'开启':'关闭' 
        }
      },
       {
        title: "手机短信",
        dataIndex: "create_time",
         customRender:({record})=>{
          return  record.sms?'开启':'关闭' 
        }
      },
       {
        title: "数据助手",
        customRender:({record})=>{
          return  record.wx?'开启':'关闭' 
        }
      },
      {
        title: "操作",
        key: "action",
        width:100,
        slots: { customRender: "action" },
      },
    ];
   const state= reactive({
      receiverVisible:false,
      confirmLoading:false,
      selectedRowKeys:[]
    })

    const  $Modal=inject('$Modal')
    // 删除接收人
    const del=(id)=>{
         $Modal.confirm({
          centered:true,
          content: '删除后该接收人将无法恢复，您确定要删除该接收人吗？', onOk:async () => {
            let res = await delReceiver(id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            }else {
              message.error(res.msg);
            }
          }
        })
    }
    const router=inject('$router')
    const set=(id)=>{
        router.push({path:'/businessCenter/subscription/singleSet',query:{type:'single',selectedRowKeys:id}})
    }
    const allSet=()=>{
      if(!state.selectedRowKeys.length){
          message.error('请勾选订阅消息')
          return;
      }
      router.push({path:'/businessCenter/subscription/set',query:{type:'more',selectedRowKeys:JSON.stringify(state.selectedRowKeys)}})
    }
    const onSelectChange=(selectedRowKeys)=>{
      state.selectedRowKeys = selectedRowKeys;
    }
    //初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let listLoading = ref(false);
    let data = ref([]);
    const initData = async (values) => {
      listLoading.value = true;
      let res = await getmessage(values).then((res) => res);
      listLoading.value = false;
      data.value = res.data.data;
    };
    initData(search.value)
    return {
      columns,
      listLoading,
      data,
      ...toRefs(state),
      set,
      allSet,
      onSelectChange
    };
  },
};
</script>